import errors from "@/logic/errors";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

export default {
  data: () => ({
    showErrorsName: false,
    showErrorsPhone: false,
    showErrorsPosition: false,
    showErrorsEmail: false,
    showErrorsReport: false,
    showErrorsActa: false,
    showErrorsDeclara: false,
    showErrorsAuditor: false,
    showErrorsReportDate: false,
    showErrorsCcaa: false,
    showErrorsActaJunta: false,
    showErrorsComplementario: false
  }),
  methods: {
    nameValidation() {
      this.showErrorsName = false;
      if (this.name === null || this.name.length === 0) {
        this.errors.push(errors.noname);
        this.showErrorsName = true;
      }
    },
    phoneValidation() {
      this.showErrorsPhone = false;
      //  eslint-disable-next-line
      const phoneformat = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
      if (this.phone === null || this.phone.length === 0 || !phoneformat.test(this.phone)) {
        this.errors.push(errors.nophone);
        this.showErrorsPhone = true;
      }
    },
    positionValidation() {
      this.showErrorsPosition = false;
      if (this.position === null || this.position.length === 0) {
        this.errors.push(errors.noposition);
        this.showErrorsPosition = true;
      }
    },
    emailValidation() {
      this.showErrorsEmail = false;
      //  eslint-disable-next-line
      const emailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.email === null || this.email.length === 0 || !emailformat.test(this.email)) {
        this.errors.push(errors.noemail);
        this.showErrorsEmail = true;
      }
    },
    reportValidation() {
      this.showErrorsReport = false;
      if (this.fileReport === null) {
        this.errors.push(errors.noreport);
        this.showErrorsReport = true;
      } else if (this.fileReport.name !== "actaconsejo.pdf") {
        this.errors.push(errors.wrongname + "actaconsejo.pdf");
        this.showErrorsReport = true;
      }
    },
    actaValidation() {
      this.showErrorsActa = false;
      if (this.fileActa === null) {
        this.errors.push(errors.nomeeting);
        this.showErrorsActa = true;
      } else if (this.fileActa.name !== "informeci.pdf") {
        this.errors.push(errors.wrongname + "informeci.pdf");
        this.showErrorsActa = true;
      }
    },
    declaraValidation() {
      this.showErrorsDeclara = false;
      if (this.fileDeclara === null) {
        this.errors.push(errors.nostatement);
        this.showErrorsDeclara = true;
      } else if (this.fileDeclara.name !== "declara.pdf") {
        this.errors.push(errors.wrongname + "declara.pdf");
        this.showErrorsDeclara = true;
      }
    },
    auditorValidation() {
      this.showErrorsAuditor = false;
      if (this.auditor === null || this.auditor.length === 0) {
        this.errors.push(errors.noauditor);
        this.showErrorsAuditor = true;
      }
    },
    reportDateValidation() {
      this.showErrorsReportDate = false;
      dayjs.extend(customParseFormat);
      const validFormats = ["D/M/YYYY", "D/MM/YYYY", "DD/M/YYYY", "DD/MM/YYYY"];
      if (this.reportDate === null || !dayjs(this.reportDate, validFormats, true).isValid()) {
        this.errors.push(errors.noreportdate);
        this.showErrorsReportDate = true;
      } else if (
        dayjs(this.reportDate, validFormats, true).startOf("day") < this.startDay ||
        dayjs(this.reportDate, validFormats, true).startOf("day") > this.endDay
      ) {
        this.errors.push(errors.noreportdateincludedinperiod);
        this.showErrorsReportDate = true;
      }
    },
    ccaaValidation() {
      this.showErrorsCcaa = false;
      if (this.fileCcaa === null) {
        this.errors.push(errors.noaccounts);
        this.showErrorsCcaa = true;
      } else if (this.fileCcaa.name !== "ccaa.pdf") {
        this.errors.push(errors.wrongname + "ccaa.pdf");
        this.showErrorsCcaa = true;
      }
    },
    actaJuntaValidation() {
      this.showErrorsActaJunta = false;
      if (this.fileActaJunta === null) {
        this.errors.push(errors.nomeeting);
        this.showErrorsActaJunta = true;
      } else if (this.fileActaJunta.name !== "actajunta.pdf") {
        this.errors.push(errors.wrongname + "actajunta.pdf");
        this.showErrorsActaJunta = true;
      }
    },
    complementarioValidation() {
      this.showErrorsComplementario = false;
      if (this.fileComplementario !== null && this.fileComplementario.name !== "informecomplementario.pdf") {
        this.errors.push(errors.wrongname + "informecomplementario.pdf");
        this.showErrorsComplementario = true;
      }
    }
  }
};
